import styled from '@emotion/styled';

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
`;
